import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { runSimulation, getSimulation, continueSimulation } from './TestProfilesService'


export const useSimulation = () => {
  const queryClient = useQueryClient()
  
  const runSimulationMutation = useMutation({
    mutationFn: runSimulation,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['simulations'] })
      queryClient.setQueryData(['simulation', data.simulation_id], data)
      toast.success('Simulation started successfully')
    },
    onError: (error) => {
      toast.error(`Error starting simulation: ${error.message}`)
    }
  })
  
  const continueSimulationMutation = useMutation({
    mutationFn: (params) => continueSimulation(params.simulation_id, params.persona_id, params.additional_turns),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['simulation', variables.simulation_id] })
      toast.success('Simulation continued successfully')
    },
    onError: (error) => {
      toast.error(`Error continuing simulation: ${error.message}`)
    }
  })
  
  /**
   * Get simulation data for a specific simulation ID
   * @param {string} simulationId - The ID of the simulation to fetch
   * @param {Object} options - Additional options for the query
   */
  const useSimulationData = (simulationId, options = {}) => {
    return useQuery({
      queryKey: ['simulation', simulationId],
      queryFn: () => getSimulation(simulationId),
      enabled: !!simulationId,
      refetchInterval: (query) => {
        if (query.error?.response?.status === 500) {
          return false
        }
        const allComplete = query.data?.personas?.every(p => 
          p.status === 'completed' || 
          p.status === 'failed' || 
          p.status === 'max_turns_reached'
        )
        return allComplete ? false : 5000
      },
      ...options
    })
  }
  
  return {
    runSimulation: runSimulationMutation.mutate,
    isRunningSimulation: runSimulationMutation.isPending,
    continueSimulation: continueSimulationMutation.mutate,
    isContinuingSimulation: continueSimulationMutation.isPending,
    useSimulationData,
  }
}